<template>
  <div>
    <el-card shadow="always">
      <el-row :gutter="5">
        <el-col :lg="8">
          <el-page-header title="Home" @back="$router.push({ name: 'home' })"
            :content="$t('cadastro-integracao')"></el-page-header>
        </el-col>
        <el-col :offset="6" :lg="3" style="margin-top: 8px;" v-if="usertype === '1'">
          <el-switch active-text="Mostrar Painel" v-model="painel"></el-switch>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="usertype !== '2' && usertype !== '5'">
          <CustomerList v-model="ruleForm.customer" v-bind:current="ruleForm.customer" v-on:selected="fetchRecords()" />
        </el-col>
      </el-row>
    </el-card>
    <IntegrationPainel v-if="usertype === '1'" v-show="painel" />
    <el-card>
      <template v-if="hasIntegrated">
        <el-divider content-position="left">Minhas lojas integradas</el-divider>
        <IntegrationAvailable ref="actives" v-bind:customer="ruleForm.customer" :tableData="tableData" :state="true"
          @refresh="fetchRecords" />
      </template>
      <el-divider content-position="left">Integrações disponíveis</el-divider>
      <IntegrationAvailable ref="available" v-bind:customer="ruleForm.customer" :tableData="tableData" :state="false"
        @refresh="fetchRecords" />
    </el-card>
  </div>
</template>
<script>
import { IntegrationService } from "@/services/customers/integration.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import IntegrationAvailable from "./components/IntegrationAvailable.vue";
import IntegrationPainel from "./IntegrationPainel";

export default {
  name: "Integration",
  components: {
    CustomerList,
    IntegrationAvailable,
    IntegrationPainel,
  },
  computed: {
    hasIntegrated() {
      return this.tableData.some((record) =>
        record.status === true || record.status === 1 || record.status === "1" ||
        record.status === "S" || record.status === "true"
      );
    },
  },
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.list(vm.ruleForm.customer)
        .then((response) => {
          vm.tableData = response.data;
          // A seção de integradas só existe no DOM quando há registro ativo
          vm.$nextTick(() => {
            if (vm.$refs.actives) vm.$refs.actives.list();
            if (vm.$refs.available) vm.$refs.available.list();
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    refresh() {
      const vm = this;
      vm.fetchRecords();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.usertype = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      filter: "",
      painel: true,
      tableData: [],
      usertype: '2',
      ruleForm: {
        customer: "",
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>